import { AxiosError } from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Input from '../../../../../../components/Input';
import Modal from '../../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../../components/Notification';
import SingleSelect from '../../../../../../components/SingleSelect';
import HttpStatus from '../../../../../../enums/httpStatus';
import { visitMotiveAPI } from '../../../../../../services/requests';
import { getOptionsMotivesSchedule } from '../../../../../../utils/getSelectOptions';

type Props = {
  closeModal: () => void;
  reqCallback: () => void;
};

const ModalCreate = ({ closeModal, reqCallback }: Props) => {
  const { t } = useTranslation();

  const [waitingRequest, setWaitingRequest] = useState(false);

  const [description, setDescription] = useState('');
  const [motiveType, setMotiveType] = useState(getOptionsMotivesSchedule()[0]);

  const reqCreate = async () => {
    setWaitingRequest(true);
    const source = visitMotiveAPI.axios.CancelToken.source();
    try {
      visitMotiveAPI.query = '';

      const res = await visitMotiveAPI.store({
        FlagMotivo: motiveType.value,
        Descricao: description,
        ATIVO: 's',
      });

      if (res.status === HttpStatus.OK) {
        setWaitingRequest(false);
        frontendNotification({
          message: t('successfullyCreated'),
          type: 'success',
        });

        closeModal();
        reqCallback();
      } else {
        throw res;
      }
    } catch (err) {
      if (!visitMotiveAPI.axios.isCancel(err)) {
        backendErrorNotification(err as AxiosError<any, any>);
      }
    }

    setWaitingRequest(false);
    return () => {
      source.cancel('Component got unmounted');
    };
  };

  return (
    <Modal
      title={t('register')}
      showModal
      closeModal={closeModal}
      action={() => reqCreate()}
      isLoading={waitingRequest}
      bodyStyle={{ overflowX: 'scroll' }}
    >
      <div>
        <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '-25px' }}>
          <div style={{ margin: '0.5rem', flex: 1 }}>
            <p style={{ marginTop: '3rem', marginBottom: '0.5rem' }}>{t('type')}</p>
            <SingleSelect
              value={motiveType}
              options={getOptionsMotivesSchedule()}
              onChange={setMotiveType as any}
              disabled={waitingRequest}
              style={{ minWidth: '150px' }}
            />
          </div>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <div style={{ margin: '0.5rem', flex: 1 }}>
            <p style={{ marginBottom: '0.5rem' }}>{t('description')}</p>
            <Input
              value={description}
              onChange={(e: any) => setDescription(e.target.value)}
              disabled={waitingRequest}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalCreate;
